<div class="flex flex-col gap-2">
  <div class="flex items-center gap-2">
    <mat-icon>fact_check</mat-icon>
    <span class="text-lg font-bold md:hidden" i18n>Fichajes</span>
  </div>

  <span class="hidden text-lg font-bold md:block" i18n> Fichajes </span>
  <p class="qaroni-common-text pe-3">
    <ng-container i18n>Registra las horas que trabajas cada día. </ng-container>
    <span class="font-bold" i18n
      >Tus turnos serán aprobados por tu manager</span
    >
  </p>
  <div class="line pt-2"></div>
</div>
